import { PropsWithChildren } from 'react'

import { Popover } from 'antd'
import { useTheme } from 'antd-style'

import { ToolbarContainerProps } from './interface'

export const ToolbarContainer = ({
  /* -------------------------------------------------------------------------- */
  /*                                Popover Props                               */
  /* -------------------------------------------------------------------------- */
  open,
  trigger,
  getPopupContainer,

  /* -------------------------------------------------------------------------- */
  /*                           ToolbarContainer Props                           */
  /* -------------------------------------------------------------------------- */
  triggerNode,
  children
}: PropsWithChildren<ToolbarContainerProps>) => {
  const theme = useTheme()

  return (
    <Popover
      arrow={false}
      content={children}
      getPopupContainer={getPopupContainer}
      open={open}
      placement='top'
      trigger={trigger}
      styles={{
        container: {
          paddingBlock: theme.paddingXS
        }
      }}
    >
      {triggerNode}
    </Popover>
  )
}
